import { render, staticRenderFns } from "./PdfFormCreate.vue?vue&type=template&id=6aba9a16&scoped=true&"
import script from "./PdfFormCreate.vue?vue&type=script&lang=js&"
export * from "./PdfFormCreate.vue?vue&type=script&lang=js&"
import style0 from "./PdfFormCreate.vue?vue&type=style&index=0&id=6aba9a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba9a16",
  null
  
)

export default component.exports